// @ts-check
import styled from 'styled-components';
import { Menu, MenuItem } from '@material-ui/core';
import { SIZES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';

export const StyledNavigationMenu = styled.div``;

export const StyledMenu = styled(Menu)`
  margin-top: 0.5rem;
`;

export const StyledMenuItem = styled(MenuItem)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.5rem 1rem;
  font-size: ${SIZES.medium};
  color: ${getColor('shuttleGray')};

  svg {
    margin-right: 0.8rem;
    width: ${SIZES.medium};
  }
`;
